import { GetInitialDataCtx, WidgetProps } from "../../contracts/widget"
import { descriptionWidgetConfig, DescriptionWidgetConfig } from "./config"
import { WidgetProvider } from "../../providers/widget"
import { DescriptionWidgetContent } from "./components/DescriptionWidgetContent"
import "./description.css"
import { useMemo } from "react"
import { parseWidgetConfig } from "@homerunner-next/widget-core/schema"

export const getInitialData = async ({ options, feedId, widgetId }: GetInitialDataCtx<DescriptionWidgetConfig>) => {
    return {}
}

export default function DescriptionWidget({ options, feedId, widgetId, resolvedTheme, data }: WidgetProps<DescriptionWidgetConfig>) {
    const parsedOptions = useMemo(() => parseWidgetConfig(descriptionWidgetConfig, options), [options])
    return (
        <WidgetProvider options={parsedOptions} feedId={feedId} widgetId={widgetId} resolvedTheme={resolvedTheme} widgetType="description" data={data ?? {}}>
            <DescriptionWidgetContent />
        </WidgetProvider>
    )
}
